document.addEventListener('DOMContentLoaded', function () {
  const specBlock = document.querySelector('.custom-specs-block');
  if (!specBlock) return;

  const toggleButton = specBlock.querySelector('.specs-toggle-button');
  const allRows = specBlock.querySelectorAll('.specs-row');
  const maxRows = parseInt(specBlock.dataset.maxRows, 10);

  let isExpanded = false;

  function updateView() {
    allRows.forEach((row, index) => {
      if (index >= maxRows) {
        if (isExpanded) {
          row.classList.remove('is-hidden');
        } else {
          row.classList.add('is-hidden');
        }
      }
    });

    toggleButton.textContent = isExpanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
  }

  toggleButton.addEventListener('click', () => {
    isExpanded = !isExpanded;
    updateView();
  });
  
  // Initialen Zustand setzen
  updateView();
});